module.exports = __webpack_public_path__ + "static/media/jblspeaker.a13829f2.jpeg";